import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.10_@babel+core@7.27.1_@playwright+test@1.58.1_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/font/local/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/GeistMonoVF.woff\",\"weight\":\"400 500 600\"}],\"variableName\":\"geistMono\"}");
;
import(/* webpackMode: "eager", webpackExports: ["ConsoleWarning"] */ "/vercel/path0/src/app/components/ConsoleWarning/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/components/DevelopmentBanner/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css");
